import styled from 'styled-components';

import { BodyStandardRegular, MinBreakpointV2 } from '@xemplo/style-constants';

export const ModalBodyContainer = styled.div`
  scroll-behavior: smooth;
  ${BodyStandardRegular};
  overflow: auto;
  overscroll-behavior: contain;
  padding: 24px 16px;
  flex: 1;
  @media ${MinBreakpointV2.medium} {
    padding: 16px 40px;
  }
`;
